<template>
  <div>
    <div class="card-header d-flex justify-content-between">
      <h6 class="lh-5 mg-b-0">Номын сангийн хяналт</h6>
      <div>
        <Select @change="init(); build();" v-model="filterModel.organizationTaskId" clearable filterable>
          <Option v-for="(b,i) in books" :key="i" :label="'('+b.total+'-c '+b.too1+' - үлд) '+b.task" :value="b.id"></Option>
        </Select>
      </div>
      <div class="d-flex">
        <!-- :f="f" -->
        <user-chooser
          :f="{
            field:{}
          }"
          @on-handle="handleUserSelected"
        ></user-chooser>
      </div>
      <div>
        <b-pagination
          v-if="allCount > 0"
          class="mg-r-20"
          size="sm"
          align="center"
          v-model="pager.page"
          :total-rows="allCount"
          :per-page="pager.size"
          @change="pageChanged"
          style="margin-bottom: 0"
        ></b-pagination>
      </div>
      
    </div>
    <div class="card-body pd-x-0 pd-y-10">
      <div
        class="
                ht-100
                d-flex
                align-items-center
                justify-content-between
                pd-x-100
              "
      >
        <div
          @click="filterListByStts(s)"
          v-for="(s, i) in stts"
          :key="i"
          class="media"
          role="button"
        >
          <div
            :class="
              `${s.color} wd-40 wd-md-50 ht-40 ht-md-50 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6`
            "
          >
            <feather type="menu"></feather>
          </div>
          <div class="media-body">
            <h6 v-html="s.title"
              class="
                      tx-sans
                      tx-uppercase
                      tx-10
                      tx-spacing-1
                      tx-color-03
                      tx-semibold
                      tx-nowrap
                      mg-b-1
                    "
            >
            </h6>
            <h4 class="tx-18 tx-sm-16 tx-md-22 tx-normal tx-rubik mg-b-0">
              {{ s.val }}
            </h4>
          </div>
        </div>
      </div>
      <vue-custom-scrollbar
        :style="`height: ${getScrollHeight(295)}`"
        class="pd-x-10"
      >
        <lib-activities
          :tasks="tasks"
          :page="pager.page"
          :size="pager.size"
          @on-decline="activitiesDeclinePrompt"
          @on-accept="acceptOrder"
          @on-giveback="giveBackOrder"
          @on-receipt="receiptOrder"
          @on-extend="extendOrder"
          @handle-info="handleUser"
        />
      </vue-custom-scrollbar>
    </div>

    <b-modal v-model="order.mdl" centered size="lg" scrollable>
      <template #modal-header="{}">
        <div class="">
          <a
            @click="order.mdl = false"
            role="button"
            class="close pos-absolute t-15 r-15"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </a>
          <div class="media align-items-center">
            <span class="tx-color-03 d-none d-sm-block">
              <feather
                type="shopping-cart"
                class="wd-40-f ht-40-f"
              ></feather>
            </span>
            <div v-if="$route.params.m == 4" class="media-body mg-sm-l-20">
              <h4 class="tx-18 tx-sm-20 mg-b-2">Захиалга баталгаажуулах</h4>
              <p class="tx-13 tx-color-03 mg-b-0">тайлбар</p>
            </div>
          </div>
        </div>
      </template>
      <div class="modal-body" v-if="$route.params.m == 4">
        <div class="d-flex align-items-center">
          <div class="mg-r-5">Хугацаа:</div>
          {{ order.task.i2 }} хоног
        </div>

        <div class="d-flex align-items-center">
          <div class="mg-r-5">Номын үлдэгдэл:</div>
          {{ order.task.organizationTask.too1 }}
        </div>
      </div>
      

      <template #modal-footer>
        
        <div class="d-flex align-items-center wd-100p">
          <button
            @click="order.mdl = false"
            
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
          >
            {{ $route.params.m == 2 ? "Хаах" : "Болих" }}
          </button>

          <button v-if="order.loading" type="button" class="btn btn-light">
            Түр хүлээнэ үү
          </button>
          <button
            v-else-if="$route.params.m == 4"
            @click="acceptOrderPost"
            type="button"
            class="btn btn-success"
          >
            Баталгаажуулах
          </button>
        </div>
      </template>
    </b-modal>

    <b-overlay :show="overlayObj.busy" no-wrap>
      <template #overlay>
        <div
          v-if="overlayObj.processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="overlayObj.busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="overlayPost()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>

  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Notification, Select, Option } from "element-ui";

import { mapActions } from "vuex";

export default {
  components: {
    vueCustomScrollbar, DatePicker, Select, Option,
    libActivities: () => ({
      component: import(
        "@/views/modules/lms/student/pages/library/components/activities.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    userChooser: () => ({
      component: import("@/components/user/chooser.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      overlayObj: {
        processing: false,
        busy: false,
        processingId: 0
      },
      filterModel: {
        task: "",
        systemFlag: null,
        organizationTaskId: null
      },
      order:{
        task:{
          organizationTask: {
            too1: null
          }
        },
        mdl: false,
      },
      stts: [],
      tasks: [],
      books: [],
      booksCur: null,
      nowDate: "",
      allCount: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.init();
    this.build();

    request({
      api: { method: "POST", url: "TaskCore/GetCoreList" },
      data: {
        skip: 0,
        size: 20000,
        ot: 181,
        model: {},
      },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        this.books = res.data.tasks;
      }
    });
  },
  methods: {
    handleUserSelected(e) {
      if (e.val == null || e.val == "") {
        this.filterModel['secondUserId']= null;
      } else {
      //   //this.$data['filterModel'][e.field]= e.val;
        this.filterModel['secondUserId'] = e.val;
      }
      // this.$emit("on-search", this.filterModel);
      this.init(); 
      this.build();
    },
    ...mapActions(["handleUserInfoModal"]),
    handleUser(e){
      this.handleUserInfoModal(e);
      // console.log('handleUser', e);
    },
    overlayPost() {
      this.overlayObj.processing = true;
      let url = "library/DeclineOrder";
      if (this.$route.params.m == 4) {
        url = "library/DeclineOrder";
      }
      request({
        data: {
          id: this.overlayObj.processingId
        },
        api: { url: url, method: "POST" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.overlayObj.busy = false;
          this.overlayObj.processing = false;
          this.tasks = [];
          this.init();
          this.initLibrarianDashboard();
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    build(){
        this.initLibrarianDashboard();
    },
    pageChanged(e) {
      this.pager.page = e;
      this.init();
    },
    getScrollHeight(mv) {
      let mh = 120;
      if (screen.width <= 1024) {
        mh = 85;
      }

      if (mv != undefined) {
        mh = mv;
      }

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    filterListByStts(e) {
      this.tasks = [];
      //console.log(e);
      if (e.id == 11) {
        this.filterModel = Object.assign(this.filterModel, {
          i1: 1,
          i7: null,
          d3End: new Date(),
        });
      }else if (e.id == 12) {
        this.filterModel = Object.assign(this.filterModel, {
          i7: 1,
          i1: null,
          d3End: null,
        });
      } else {
        this.filterModel = Object.assign(this.filterModel, {
          i1: e.id,
          i7: null,
          d3End: null,
        });
      }
      //console.log(this.filterModel);
      this.init();
    },
    initLibrarianDashboard() {
      request({
        api: { method: "GET", url: "Library/LibrarianDashboard" },
        params:{
          bookId: this.filterModel.organizationTaskId
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.stts = [];
          this.stts.push({
            id: null,
            title: "Нийт<br/> захиалга",
            icon: "",
            val: res.data.stat.order.allCount,
            color: "bg-primary",
            order: 1,
          });
          this.stts.push({
            id: -1,
            title: "Цуцалсан<br/> захиалга",
            icon: "",
            val: res.data.stat.order.declinedCount,
            color: "bg-secondary",
            order: 2,
          });
          this.stts.push({
            id: 2,
            title: "Буцаан<br/>авсан",
            icon: "",
            val: res.data.stat.order.returnedCount,
            color: "bg-success",
            order: 2,
          });
          this.stts.push({
            id: 0,
            title: "Шинэ <br/>захиалгууд",
            icon: "",
            val: res.data.stat.order.inProgressCount,
            color: "bg-warning",
            order: 2,
          });
          this.stts.push({
            id: 1,
            title: "Баталгаажсан<br/>захиалгууд",
            icon: "",
            val: res.data.stat.order.acceptedCount,
            color: "bg-info",
            order: 2,
          });

          this.stts.push({
            id: -2,
            title: "Хүлээлгийн <br/>жагсаалт",
            icon: "",
            val: res.data.stat.order.waitingListCount,
            color: "bg-purple",
            order: 2,
          });

          this.stts.push({
            id: 11,
            title: "Хугацаа <br/>хэтэрсэн",
            icon: "",
            val: res.data.stat.order.overdueCount,
            color: "bg-danger",
            order: 2,
          });

          this.stts.push({
            id: 12,
            title: "Сунгах <br/>хүсэлт",
            icon: "",
            val: res.data.stat.order.notAccepted7DayRequestCount,
            color: "bg-orange",
            order: 2,
          });
          //console.log(res.data.stat);
        }
      });
    },
    activitiesDeclinePrompt(e) {
      this.overlayObj.processingId = e.id;
      this.overlayObj.busy = true;
    },
    extendOrder(e){
      if (confirm("Итгэлтэй байна уу ?. Үйлдлийг зөвшөөрснөөр буцаах боломжгүй")) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Library/Accept7DayRequest" },
          data: {
            id: e.id,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.init();
            this.initLibrarianDashboard();
          }
        });
      }
    },
    giveBackOrder(e) {
      request({
        data: {
          id: e.id,
        },
        api: { url: "library/GiveBackTheBook", method: "POST" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.init();
          this.initLibrarianDashboard();
          Notification.info({
            message: res.msg,
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50,
          });
        }
      });
    },
    receiptOrder(e){
      if (confirm("Итгэлтэй байна уу ?")) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Library/ChangeOrderStatus" },
          data: {
            id: e.id,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.init();
            this.initLibrarianDashboard();
          }
        });
      }
    },
    acceptOrder(e) {
      //console.log('acceptOrder ',e);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: e.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('taskInheritedDetail', e, res);
          this.order.task = res.data.task;
          this.order.task.d3 = moment(new Date(), "DD-MM-YYYY")
            .add(3, "days")
            .format("YYYY-MM-DD");
          this.order.mdl = true;
        }
      });
    },
    acceptOrderPost() {
      request({
        data: {
          id: this.order.task.id,
          date: this.order.task.d3
        },
        api: { url: "library/AcceptOrder", method: "POST" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.order.mdl = false;
          this.init();
          this.initLibrarianDashboard();
          Notification.info({
            message: res.msg,
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        }
      });
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: (this.pager.page-1)*this.pager.size,
          size: this.pager.size,
          ot: 504,
          model: this.filterModel,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.nowDate = res.data.nowDate;
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
  },
};
</script>
